import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from './firebaseConfig';
import { collection, onSnapshot } from 'firebase/firestore';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from './logo.png'; 

const COLORS = ['#FBBF24', '#3B82F6', '#10B981', '#9CA3AF'];

function Reports() {
  const [projects, setProjects] = useState([]);
  const [pieData, setPieData] = useState([]);

  useEffect(() => {
    return onSnapshot(collection(db, "projects"), (snapshot) => {
      const projs = snapshot.docs.map(d => ({id: d.id, ...d.data()}));
      setProjects(projs);
      
      const counts = { 'Em desenvolvimento': 0, 'Homologação': 0, 'Produção': 0, 'Finalizado': 0 };
      projs.forEach(p => {
        if(counts.hasOwnProperty(p.status)) counts[p.status] += 1;
      });
      
      setPieData([
        { name: 'Em desenvolvimento', value: counts['Em desenvolvimento'] },
        { name: 'Homologação', value: counts['Homologação'] },
        { name: 'Produção', value: counts['Produção'] },
        { name: 'Finalizado', value: counts['Finalizado'] },
      ]);
    });
  }, []);

  const exportPDF = () => {
    const doc = new jsPDF();
    doc.addImage(logo, 'PNG', 14, 10, 40, 15);
    doc.setFontSize(18);
    doc.text("Relatório - Desenvolvimentos", 60, 20); // Nome do relatório alterado
    
    const tableColumn = ["Projeto", "Solicitante", "Status", "Prazo"];
    const tableRows = projects.map(p => [p.name, p.requester || 'N/A', p.status, p.deadline || 'N/A']);
    
    autoTable(doc, { head: [tableColumn], body: tableRows, startY: 40 });
    doc.save("Relatorio_Desenvolvimentos.pdf"); // Nome do arquivo alterado
  };

  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <Link to="/" className="text-blue-600 font-bold mb-6 block">&larr; Voltar ao Dashboard</Link>
      
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Relatório Executivo</h2>
        <button onClick={exportPDF} className="bg-red-600 text-white font-bold py-2 px-4 rounded shadow hover:bg-red-700">Exportar PDF</button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
        <div className="bg-white p-6 rounded-lg shadow-md h-96">
          <h3 className="font-bold mb-4">Distribuição por Status</h3>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie data={pieData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label>
                {pieData.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)}
              </Pie>
              <Tooltip />
              <Legend verticalAlign="bottom" />
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        {/* Adicionei os cards de resumo de volta */}
        <div className="grid grid-cols-2 gap-4">
          {pieData.map((item) => (
            <div key={item.name} className="bg-white p-4 rounded shadow border-l-4 border-blue-500">
              <h3 className="text-gray-500 font-bold text-xs uppercase">{item.name}</h3>
              <p className="text-3xl font-bold text-gray-800">{item.value}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Tabela Restaurada */}
      <div className="bg-white p-6 rounded shadow overflow-x-auto">
        <h3 className="text-xl font-bold mb-4">Lista Completa de Projetos</h3>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-gray-50 text-gray-600 text-sm">
              <th className="p-3 border-b">Projeto</th>
              <th className="p-3 border-b">Solicitante</th>
              <th className="p-3 border-b">Status</th>
              <th className="p-3 border-b">Prazo</th>
            </tr>
          </thead>
          <tbody>
            {projects.map(p => (
              <tr key={p.id} className="border-b hover:bg-gray-50 text-sm">
                <td className="p-3 font-medium">{p.name}</td>
                <td className="p-3">{p.requester || 'N/A'}</td>
                <td className="p-3">{p.status}</td>
                <td className="p-3">{p.deadline || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default Reports;